import { forwardRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import backFill from '@iconify/icons-eva/arrow-back-fill';
// material
import CloseIcon from '@material-ui/icons/Close';
import { Slide, Button, Dialog, Divider, Box, Grid, IconButton, Stack } from '@material-ui/core';
import { useNavigate } from 'react-router';
import { useSelector } from 'react-redux';
// eslint-disable-next-line import/no-unresolved
import { PATH_DASHBOARD } from 'src/routes/paths';
import EmptyContent from '../EmptyContent';

// ----------------------------------------------------------------------
FullDialog.propType = {
  btnName: PropTypes.string,
  endIcon: PropTypes.object,
  showIcon: PropTypes.bool,
  icon: PropTypes.object,
  data: PropTypes.array,
  CalledComponent: PropTypes.elementType,
  nextButton: PropTypes.bool,
  nextButtonTitle: PropTypes.string,
  backButtonTitle: PropTypes.string
};
const Transition = forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

export default function FullDialog({
  nextButtonTitle = '',
  nextButton = false,
  backButtonTitle = '',
  CalledComponent,
  data,
  btnName = '',
  endIcon = {},
  icon = {},
  showIcon = false
}) {
  const { appliedRuleFile } = useSelector((state) => state.collection);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      {showIcon ? (
        <IconButton onClick={handleClickOpen}>
          <Icon icon={icon} />
        </IconButton>
      ) : (
        <Button
          disabled={!appliedRuleFile}
          endIcon={<Icon icon={endIcon} />}
          variant="contained"
          onClick={handleClickOpen}
        >
          {btnName}
        </Button>
      )}

      <Dialog
        fullScreen
        open={open}
        style={{ overflow: 'hidden' }}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <Stack spacing={3}>
              <Stack
                sx={{ m: 2 }}
                direction={{ xs: 'column', sm: 'row' }}
                spacing={{ xs: 3, sm: 2 }}
                justifyContent="space-between"
                alignItems="center"
              >
                <IconButton color="inherit" onClick={handleClose}>
                  <CloseIcon />
                </IconButton>
                <Box direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                  <Button sx={{ mr: 1 }} variant="outlined" onClick={handleClose} startIcon={<Icon icon={backFill} />}>
                    {backButtonTitle}
                  </Button>
                  {nextButton && (
                    <Button variant="contained" onClick={() => navigate(PATH_DASHBOARD.general.segmentation)}>
                      {nextButtonTitle}
                    </Button>
                  )}
                </Box>
              </Stack>
              <Stack>
                <Divider />
              </Stack>
              <Box style={{ margin: '16px' }}>
                {data && data.length !== 0 ? <CalledComponent Data={data} /> : <EmptyContent title="Empty File" />}
              </Box>
            </Stack>
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
}
